import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import reviewImg from '../../../images/webp/review.webp';
import ceoImg from '../../../images/png/ceo.jpg';

const Review = () => {
    return (
        <div style={{marginTop: 80}} className="row">
            <div data-aos="fade-down" data-aos-duration="2000" className="col-md-6">
                <img className="w-100" src={reviewImg} alt="" />
            </div>
            <div className="col-md-6">
                <h1 data-aos="fade-down" data-aos-duration="1500" className="text-warning"><FontAwesomeIcon icon={faStar}/> <FontAwesomeIcon icon={faStar}/> <FontAwesomeIcon icon={faStar}/> <FontAwesomeIcon icon={faStar}/> <FontAwesomeIcon icon={faStar}/> <span style={{color: 'gray'}}><FontAwesomeIcon icon={faStar}/></span></h1>
                <h2 data-aos="fade-down" data-aos-duration="2500">Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint velit officia consequat duis enim velit mollit exercitation veniam.</h2>
                <div data-aos="fade-down" data-aos-duration="3000" className="mt-5 d-flex align-items-center">
                    <img style={{height: 70, padding: 2, borderRadius: '50%', marginRight: 5}} src={ceoImg} alt="" />
                    <h5 className="fw-bolder">Kristin Watson / <span style={{ color: '#ff3465', fontWeight: 400 }}>CEO, Rome</span></h5>
                </div>
            </div>
        </div>
    );
};

export default Review;